class SrollertoTop {
  constructor() {
    // We select the element we want to target
    this.AppWrapper = document.getElementById("content");
    this.scrollToTopBtn = document.querySelector(".scrollToTopBtn")
    this.events()
    
  }

  events() {
    
    // document.addEventListener("scroll", handleScroll)
    // this.AppWrapper.addEventListener("scroll", () => this.handleScroll())
    
    window.addEventListener("scroll", () => {

      const scrollTop = document.getElementsByTagName("html")[0].scrollTop ||  document.body.scrollTop;
      if (scrollTop > 90 ) {
        this.scrollToTopBtn.classList.add("showBtn")
      } else {
        this.scrollToTopBtn.classList.remove("showBtn")
      }

    });

  }

  handleScroll() {
    var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
    if ((rootElement.scrollTop / scrollTotal ) > 0.80 ) {
      // Show button
      scrollToTopBtn.classList.add("showBtn")
    } else {
      // Hide button
      scrollToTopBtn.classList.remove("showBtn")
    }
  }
  
}

export default SrollertoTop